import React, { createContext, useContext } from "react";

type NotificationPayload = string | { type?: string; title?: string; message: string };

interface NotificationContextType {
  notify: (message: NotificationPayload) => void;
  addNotification: (message: NotificationPayload) => void;
}

const NotificationContext = createContext<NotificationContextType>({
  notify: () => {},
  addNotification: () => {},
});

export function useNotifications() {
  return useContext(NotificationContext);
}

export function NotificationProvider({ children, position, maxVisible }: { children: React.ReactNode; position?: string; maxVisible?: number }) {
  return (
    <NotificationContext.Provider value={{ notify: () => {}, addNotification: () => {} }}
      data-position={position}
      data-max-visible={maxVisible}>
      {children}
    </NotificationContext.Provider>
  );
}
